import React, { Component } from 'react';
import { producaov2 as api } from '../../services/apis';
import { Container } from 'semantic-ui-react';
import DuvidaEditor from './DuvidaEditor';
import swal from 'sweetalert';

class DuvidasEditarSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            content: '',
            id_pessoa: null,
            id_duvida: null
        }
    }

    componentDidMount() {
        const { idResposta } = this.props;
        api.get(`ticket/resposta/${idResposta}`)
            .then(({ data }) => {
                this.setState({ 
                    content: data.mensagem, 
                    id_pessoa: data.id_pessoa, 
                    id_duvida: data.id_duvida 
                });
            });
    }

    sendResposta = async mensagem => {
        const { id_pessoa, id_duvida } = this.state;
        const { idResposta } = this.props;
        const data = {
            id_pessoa,
            id_duvida,
            mensagem,
            url: ""
        };

        api.put(`ticket/resposta/${idResposta}`, data)
            .then(({ data }) => {
                swal('Alteração concluída !', 'Alteração na resposta foi bem sucedida.', 'success');
            })
            .catch( err => {
                swal('Alteração não concluída !', 'Alteração falhou.', 'error');
            })
    }

    render() {
        const { content } = this.state;
        return(
            content && <div>
                <Container>
                    <h2 style={{ fontFamily: 'Montserrat' }}>Editar Ticket #{this.props.idResposta}</h2>
                    <DuvidaEditor content={content} sendResposta = { mensagem => this.sendResposta(mensagem)} />
                </Container>
            </div>
        );
    }
}

export default DuvidasEditarSection;